import {Injectable} from '@angular/core';
import {SearchAndPaginationService} from "app/shared/services/search-and-pagination.service";
import {AppConstants} from "app/utils/constants";
import {ActivatedRoute} from "@angular/router";

@Injectable()
export class PreviousPageService {

  private previousPage: string;
  private lastPage: string;

  constructor(
    private _searchAndPaginationService: SearchAndPaginationService,
    private _activatedRoute: ActivatedRoute,
  ) {
  }

  public setPreviousPage(urlAfterRedirects: string) {
    if (!this.lastPage && !this.previousPage) {
      this.previousPage = '';
      this.lastPage = urlAfterRedirects;
    } else {
      this.previousPage = this.lastPage;
      this.lastPage = urlAfterRedirects;
    }

    let previousPageBaseUrl = '';
    if (this.previousPage) {
      previousPageBaseUrl = this._getBaseUrl(this.previousPage);
    }

    let lastPageBaseUrl = this._getBaseUrl(this.lastPage);

    if (!(((previousPageBaseUrl === AppConstants.slxAdminManageUsers || previousPageBaseUrl === AppConstants.slxAdminManageCustomers) &&
      (lastPageBaseUrl === AppConstants.slxUserDetailPath || lastPageBaseUrl === AppConstants.createCustomer || lastPageBaseUrl === AppConstants.editCustomer)) ||
      ((previousPageBaseUrl === AppConstants.slxUserDetailPath || previousPageBaseUrl === AppConstants.createCustomer || previousPageBaseUrl === AppConstants.editCustomer) &&
        (lastPageBaseUrl === AppConstants.slxAdminManageUsers || lastPageBaseUrl === AppConstants.slxAdminManageCustomers)))) {
      this._searchAndPaginationService.resetValues();
    }
  }

  public getPreviousPage() {
    return this.previousPage;
  }

  private _getBaseUrl(url) {
    let baseUrl: string;

    if (this._activatedRoute.snapshot.queryParams) {
      baseUrl = url.split('/')[1].split('?')[0];
    } else {
      baseUrl = url.split('/')[1];
    }

    return baseUrl;
  }
}
